interface StringResources {
  [key: string]: string;
}

const strings: StringResources = {
  //Common page
  "common.bookmark.more.hotels": "Bookmark More Hotels",
  "common.inProgress": "In Progress",
  "common.not.inProgress": "Not In Progress",
  "common.bookmarkedHotels": "Bookmarked Hotels",
  "common.bookmarkedPlans": "Bookmarked Plans",
  "common.myPlans": "My Plans",
  "common.libraryPlans": "Library Plans",
  "common.templatePlans": "Template Plans",
  "common.propertyPlans": "Property Plans",
  "common.viewPlanDetails": "View Plan Details",
  "common.planNoLongerInLibrary": "The plan is no longer available in Library",
  "common.remove": "Remove",
  "common.proceed": "Proceed",
  "common.seeAll": "See all",
  "common.seeLess": "See less",
  "common.seeMore": "See More",
  "common.seeLessUpper": "See Less",
  "common.includeAboveProperty": "Include Above Property",
  "common.excludeAboveProperty": "Exclude Above Property",
  "common.overdue": "Overdue",
  "common.completed": "Completed",
  "common.totalActive": "Total Active",
  "common.pastDays": "Past 90 Days",
  "common.showing": "Showing",
  "common.showing.abovePropertyMember": "Above Property Member",
  "common.showing.onPropertyMember": "On Property Member",
  "common.seeAll.properties": "See All Properties",
  "common.seeAll.plans": "See All plans",
  "common.no.filter.selected": "Select a preference",
  "common.myListsLabel": "My Lists",
  "common.allListsLabel": "All Lists",
  "common.noResults": "No Results",
  "common.renameList": "List name is updated.",
  "common.addTeamMembers": "Add Team Member(s)",
  "common.description": "Add a short description.",
  "common.addUser": "Add User",
  "common.importFile": "Import file",
  "common.recentlyViewed": "  Recently Viewed",
  "common.noRecentlyViewedData": "  You have no Recently Viewed",
  "common.planAssignment": "Plan Assignment",
  "common.lastAssignment": "Last Assignment",
  "common.defaultSystemList": "Default View",
  "common.memberNotFound": "The member you searched isn't found as owner of this plan.",
  "common.addTeamMember": "Add Team Member",
  "common.targetedPlan": "Master Plan",
  "common.targetedPlanTooltip": "This is the Master Plan view not specific to an inncode.",
  "common.noMemberFound": "No member found.",
  "common.planAssigmentLimit":
    "Maximum limit of {PlanAssigmentLimit} assignments reached, adjust your assignments into more than one bulk group.",
  "common.planSelectionLimit":
    "Maximum limit of {PlanSelectionLimit} plans in one assignment has reached, adjust assignments for other plans in next group assignment.",
  "common.noSummary": "No summary available.",

  //List
  "list.inncodes.already.exist": "The list name already exists",
  "list.property.already.exist": "The Property list name already exists",
  "list.Filter.already.exist": "The list name already exists",
  "list.create.inncode": "Create Inncode List",
  "list.create.inncode.title": "Create New List",
  "list.chooseType": "Choose type of list",
  "list.savedProperty.type": "Property List",
  "list.SC.type": "Consultant List",
  "list.name.label": "Name your list before saving.",
  "list.addInncode.label": "Search to Add Inncodes to the List",
  "list.searchInncode": "Search to add inncodes to the list",
  "list.uploadFile.placeholder": "Use the download template to create Inncode list.",
  "list.downloadTemplate": "Download Template",
  "list.downloadTemplate.placeholder": "Use the button below to upload your Excel File with the Inncode list.",
  "list.createScratch": "Create Custom List",
  "list.uploadInncode": "Import Inncode List",
  "list.uploadInncode.placeHolder": "Upload Excel File",
  "list.uploadInncode.uploadInfo": "You can create lists from the",
  "list.uploadInncode.success": "List was successfully imported",
  "list.created.success": "List was successfully created",
  "list.updated.success": "List was successfully updated",
  "list.edit.list.title": "Edit List",
  "list.rename.list": "Rename List",
  "list.update.description": "Update Description",
  "list.list.name.placeholder": "List Name",
  "list.list.description.placeholder": "Description here",
  "list.delete.dynamic.filter.dailog.title": "Delete Saved Filters",
  "list.delete.static.filter.dailog.title": "Delete Saved Property List",
  "list.delete.dynamic.filter.dailog.description": "Please confirm you want to remove this filter list.",
  "list.delete.static.filter.dailog.description": "Please confirm you want to remove this property list.",
  "list.delete.common.filter.dailog.description.secondary": "Click Delete to proceed.",
  "list.add.remove.inncodes": "Add or Remove Inncodes",

  //Dashboard Page
  "dashboard.heading": " My Portfolio Dashboard",
  "dashboard.saveListTitle": "Save to My Lists",
  "dashboard.saveFilters": "Save Filter Selection",
  "dashboard.saveFiltersDescription": "Use this option to save the filters selected for future monitoring or review.",
  "dashboard.saveProperty": "Save Property Selection to List",
  "dashboard.savePropertyDescription":
    "Use this option to save this selected property list as a consistent hotel group to monitor or review.",
  "dashboard.saveConsultant": "Save Consultant List",
  "dashboard.saveConsultantDescription": "Use this option to save as a Consultant List.",
  "dashboard.hotelView": "Hotel View",
  "dashboard.planView": "Plan View",
  "dashboard.bookmarkThisHotel": "Bookmark this Hotel",
  "dashboard.bookmarkThisPlan": "Bookmark this Plan",
  "dashboard.removeBookmark": "Remove Bookmark",
  "dashboard.assigned.progress.completed": "Assigned, In Progress & Completed",
  "dashboard.assigned.templatePlans": "Assigned Template Plans",
  "dashboard.brand.deadlines": "Brand Deadlines",
  "dashboard.initiatives": "Initiatives",
  "dashboard.planInProgress": "Plan in Progress",
  "dashboard.bookmark.hotels": "Bookmark More Hotels",
  "dashboard.PlanView.BrandDeadline": "brandDeadlineFilters",
  "dashboard.PlanView.FunctionalArea": "Functional Areas",
  "dashboard.PlanLabel": "Plans",
  "dashboard.propertyLabel": "Properties",
  "dashboard.ChangeEmail": "Change Email",
  "dashboard.UpdateEmail": "Update email",
  "dashboard.SearchBarPlaceholder": "Search by plan title",
  "dashboard.IndividualProperty.Initiative": "initiatives",
  "dashboard.AboveProperty.Bookmarked.Template": "Template",
  "dashboard.PreferredEmailTitle": "All of your BOOST messages and notifications are being sent to ",
  "dashboard.PreferredEmailDescription": "You will not receive email notifications as your Email Id is not available.",
  "dashboard.AboveProperty.assignmentSummary": "All actions will be automatically assigned to the Plan Owner.",
  "dashboard.planAssignment.plan": "Plan Assignment - Plan Selection",
  "dashboard.planAssignment.user": "Plan Assignment - User Selection",
  "dashboard.focusedArea.flagTrue.desktop": "Note: There are new focus areas!",
  "dashboard.focusedArea.flagTrue.mobile": "New focus areas",
  "dashboard.actionsLabel": "Actions",
  "dashboard.noBookMarkedProperties": "You have no Bookmarked Properties",
  "dashboard.noBookMarkedPlans": "You have no Bookmarked Plans",
  "dashboard.wizard.corp": "Welcome! Use the Wizard to select preference(s).",
  "dashboard.wizard.corp.subHeading": "You can update your preference(s) at any time.",
  "dashboard.suggestedplans": "Suggested Plans",

  //My Plan Page
  "myplan.createTemplatePlan": "A plan with no inncode associated",
  "myplan.TemplatePlan": "New Template Plan",
  "myplan.createPropertyPlan": "A plan for specific Inncode",
  "myplan.PropertyPlan": "New Property Plan",
  "myPlan.importFromLibrary.feedback": "Action(s) Added. Well-done customizing your plan!",
  "myPlan.addSection.feedback": "Section Added",
  "myPlan.removeUser.popup.heading": "Remove Member",
  "myPlan.removeUser.popup.desc": "Action(s) will be reassigned to the Plan Owner. Do you wish to proceed?",
  "myPlan.myCompleted.popup.desc":
    "{totalAction} action(s) {prep} the entire {plan} will be marked completed, including those <strong>not</strong> assigned to you.",
  "myPlan.myCompletedTask.popup.desc":
    "{totalAction} action(s) assigned to you will be marked completed. To mark the entire plan complete, unclick the Highlight My Actions button.",
  "myPlan.changeAction.status.popup":
    "This action is not assigned to you. Do you want to proceed to update the status?",
  "myPlan.actionDisabled.feedback":
    "This action is not assigned to you. To manage actions on the entire plan, unclick the Highlight My Actions button.",
  "myplan.actionCompleted.feedback": "All actions are already marked completed.",
  "myplan.removeAssigee.popup.desc":
    "The Plan Member will be removed from the plan and any actions. Do you wish to proceed?",
  "myPlan.sectionHeader.completed.heading": "Are you sure you want to proceed and mark the {plan} complete?",
  "myplan.myCompletedTask.popup.heading.highlightToggle":
    "Are you sure you want to proceed and mark the plan complete?",
  "myplan.highlight.myActions": "Highlight My Actions",
  "myPlan.reassignOwner": "Reassign to Plan Owner",
  "myPlan.inviteMember.popup": "Select the user(s) to be added to this plan.",
  "myPlan.createNewAction": "Create new action",
  "myPlan.editAction": "Edit action",
  "myPlan.memberRemoval": "Plan Member Removed",

  //Library page
  "library.addToMyPlan": "Add to My Plans",
  "library.addToMyPlan.popup.desc": "Brand deadline date is ",
  "library.copyActionToMyPlan.popup.title": "Copy action to a plan",
  "library.planDetails.section.kebabMenu.copyLinkTitle": "Copy shareable link",
  "library.planDetails.section.kebabMenu.copySectionTitle": "Copy Section to Plan",
  "library.addToMyPlan.popup.subDesc": "Select Date will allow you to set a different due date.",
  "library.addToMyPlan.popup.beyondDate": "Selected date is later than the deadline. Do you want to continue?",

  //Impersonate page
  "impersonate.header.tooltip":
    "Locate the On- or Above-Property user you wish to impersonate by searching for one of their associated Inncodes.",

  "user.restrictAccess":
    "You do not have permission to use this function. Reach out to BOOST.Support@hilton.com for more information or to request access.",

  "globalSearch.recentPlan.search": "Recent Plan search:",
  "globalSearch.recentProperty.search": "Recent Property search:",
  "globalSearch.recentUser.search": "Recent Member search:",

  //Admin console
  "adminConsole.header": "Permissions for Corporate Users",
  "adminConsole.confirmation": "This user will receive an email notifying them of these changes.",
  "adminConsole.editPermission.successMessage": "User permissions have been updated.",
  "adminConsole.myPermission.heading": "My permissions",
  "adminConsole.myPermission.footer": "Need to update your permissions? Please contact your Admin at ",

  //logout
  "logout.logoutHeader": "You're about to be logged out!",
  "logout.logoutMessage1": `You have been idle for some time. You’ll be logged out soon.`,
  "logout.logoutMessage2": `Click “Extend Session” to stay signed in.`,

  //Manage Suggestions
  "manageSuggestions.header": "Manage Suggested Plans",
  "manageSuggestions.subHeading":
    "Text that tells user that this page enables them to view suggestions by inncode and add suggestions. ",
  "manageSuggestions.inncodeList": "Inncode List",

  //My Plan Details Page
  "myplanDetails.inActivity":
    "Notice! No Plan Members have had any activity since MM/DD/YYYY. Review the status, mark completed, or delete the plan.",
  "myplanDetails.inActivityForCorp": "Notice! No Plan Members have had any activity since MM/DD/YYYY.",
  "myplanDetails.planJoined": "You have successfully joined the Plan.",

  //Feedback
  "feedback.header": "Feedback Forms",
  "feedback.noFeedbackFormsFound": "No Feedback Forms found.",
  "feedback.giveFeedbackCommonLabel": "Give feedback, help us improve BOOST",

  //Export
  "export.header": "Export Feedback Data",

  //Custom Plan Creation
  "custom.plan.creation.title": "Create Custom Plan",
  "custom.template.plan.creation.title": "Create Template Plan",
  "custom.plan.creation.step1": "Plan Details",
  "custom.plan.creation.step2": "Add Sections and Actions",
  "custom.plan.creation.step3": "Add Plan Members",
  "custom.plan.creation.step0": "Customize Plan",
  "custom.plan.creation.template.success": "Template Plan added successfully",

  //Onboarding
  "onboarding.setPreferences": "Set preferences that fit you and match your goals to tailor your experience.",
  "onboarding.preferences": "Update your preferences to align with your current goals and tailor your experience.",
  "onboarding.new.focusAreas": "New Focus Areas are now available."
};

export default strings;
